export default {
    aggregateChart: {
        forecastFutures: 'napoved + futures',
        futuresOnly: 'samo futures',
        finalPosition: 'Končna pozicija',
        netPositionAxis: 'Neto pozicija (MWh)  ·  + KRATKA  /  − DOLGA',
        short: 'KRATKA',
        long: 'DOLGA',
        flat: 'nevtralno',
        hrForecast: 'HR · napoved',
        hrFutures: 'HR · futures',
        siForecast: 'SI · napoved',
        siFutures: 'SI · futures',
        ariaLabel: 'Agregatni grafikon zloženih pozicij med pogodbami, {country}',
        allCountries: 'vse države',
        noForecastNotePre: 'Ni napovedi za to obdobje — pasovi prikazujejo',
        noForecastNoteRest:
            '(osnovna napoved je nič). Ko bo napoved obdelana, se bo pojavila tukaj.',
        signPre: 'Neto pozicija —',
        signAbove: 'nad 0 = KRATKA',
        signAboveDesc: '(premalo nabavljeno, kupite več) ·',
        signBelow: 'pod 0 = DOLGA',
        signBelowDesc:
            '(preveč nabavljeno, presežek za prodajo). Nakup nadomesti povpraševanje, zato premakne črto navzdol.',
    },
}
